import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const POST_ANSWER = gql`
  mutation AddAnswer($input: AddAnswerInput!) {
    addAnswer(input: $input) {
      body
      addedBy {
        ...identificationFields
      }
      isAuthorAnonymous
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

// Update answer content
export const ANSWER_CONTENT_UPDATE = gql`
  mutation UpdateMainContent($input: AnswerContentUpdateInput!) {
    answerContentUpdate(input: $input) {
      body
      addedBy {
        ...identificationFields
      }
      isAuthorAnonymous
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

// User actions (comment, vote, bookmark)
export const ANSWER_ACTIONS_UPDATE = gql`
  mutation UserActionsUpdate($input: AnswerActionsUpdateInput!) {
    answerActionsUpdate(input: $input) {
      body
      addedBy {
        ...identificationFields
      }
      isAuthorAnonymous
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;
